import React, { useRef } from 'react';
export function Bestsellers() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const products = [{
    name: 'Cloudlux Cross-Waist Set',
    price: '98.00',
    image: 'https://cdn.magicpatterns.com/uploads/ohCc4TtyugjJt1aZHnvEMc/IMG_0167.webp',
    colors: ['#E7DDD0', '#5C4033', '#7A1F2B', '#F4C2C2']
  }, {
    name: 'Off-Shoulder Long Sleeve',
    price: '58.00',
    image: 'https://cdn.magicpatterns.com/uploads/pPLA8yNeRf7vSZxW56x2EA/IMG_9842.webp',
    colors: ['#5C4033', '#7A1F2B', '#F4E8A8']
  }, {
    name: 'Pilates Flare Pants',
    price: '78.00',
    image: 'https://cdn.magicpatterns.com/uploads/nsP2eQrKr2tZAxiDHwxEGh/IMG_9831.webp',
    colors: ['#2B3A5C', '#6B7A99', '#C8B6E2', '#F4E8A8']
  }, {
    name: 'Pilates Claw Clip',
    price: '15.00',
    image: 'https://cdn.magicpatterns.com/uploads/71P6ewbvSyG3Q6YSofSt4k/IMG_9931.webp',
    colors: ['#5C2B2B']
  }];
  return <section className="py-16 md:py-24 px-6 bg-sand" data-id="element-19">
      <div className="max-w-7xl mx-auto" data-id="element-20">
        <div className="text-center mb-12" data-id="element-21">
          <p className="text-xs uppercase tracking-widest text-espresso mb-4" data-id="element-22">
            BESTSELLERS
          </p>
          <h2 className="font-serif font-light text-3xl md:text-4xl text-espresso" data-id="element-23">
            The pieces everyone loves.
          </h2>
        </div>

        <div ref={scrollRef} className="flex gap-6 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide md:grid md:grid-cols-4 md:overflow-visible" data-id="element-24">
          {products.map(product => <a key={product.name} href="https://shop.purepulsepilates.com" className="flex-shrink-0 w-[280px] md:w-auto snap-start group block" data-id="element-25">
              <div className="relative aspect-[3/4] mb-4 overflow-hidden" data-id="element-26">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-27" />
                <span className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-cream text-espresso px-6 py-3 rounded-full text-sm uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-300 min-h-[44px] flex items-center" data-id="element-28">
                  Quick Add
                </span>
              </div>
              <h3 className="text-espresso mb-1" data-id="element-29">{product.name}</h3>
              <p className="text-espresso font-medium mb-2" data-id="element-30">${product.price}</p>
              <div className="flex gap-2" data-id="element-31">
                {product.colors.map((color, idx) => <span key={idx} className="w-6 h-6 rounded-full border border-espresso/20 block" style={{
              backgroundColor: color
            }} aria-label={`Color option ${idx + 1}`} data-id="element-32" />)}
              </div>
            </a>)}
        </div>

        <div className="text-center mt-12" data-id="element-33">
          <a href="https://shop.purepulsepilates.com" className="inline-block text-espresso uppercase tracking-widest text-sm border-b border-rust pb-1 hover:text-rust transition-colors" data-id="element-34">
            VIEW ALL PRODUCTS
          </a>
        </div>
      </div>
    </section>;
}